export const membersInfo = [
  {
    id: 0,
    name: "Julia Vu",
    year: "Bioengineering '26",
    img: {
      src: "https://static.igem.wiki/teams/4951/wiki/team-photos/julia-c.jpg",
      alt: "Picture of Julia Vu",
    },
    imgFun: {
      src: "https://static.igem.wiki/teams/4951/wiki/team-photos/julia2.jpg",
      alt: "Fun Picture of Julia",
    },
    email: "juliavu@stanford.edu",
    linkedin: "https://www.linkedin.com/in/julia-p-vu/",
    bio: "From San Ramon, California, Julia is a driven sophomore majoring in Bioengineering. Her scientific journey began in a drug discovery lab, exploring solutions for cancer, COVID-19, and neurodegenerative diseases. Currently she works on single-cell growth dynamics using intravital imaging at the Skotheim Lab at Stanford. Currently, she researches the connection between METTL13 demethylation of eEF1A and translational output in neoplastic growth. Outside the lab, Julia's diverse interests include slam poetry, baking, contemplative walks, and engaging conversations.",
  },
  {
    id: 1,
    name: "Ngoc Tran",
    year: "Computer Science '26",
    img: {
      src: "https://static.igem.wiki/teams/4951/wiki/team-photos/ngoc-c.jpg",
      alt: "Picture of Ngoc Tran",
    },
    imgFun: {
      src: "https://static.igem.wiki/teams/4951/wiki/team-photos/ngoc2.jpg",
      alt: "Fun Picture of Ngoc Tran",
    },
    email: "nhtran@stanford.edu",
    linkedin: "https://www.linkedin.com/in/ngoc-tran-4882b1245/",
    bio: "Ngoc is a sophomore from Austin, Texas, who plans to major in Computer Science with a specialization in the HCI and Visual Computation tracks. With a keen interest in biotechnology and game development, Ngoc is dedicated to advancing the boundaries of scientific innovation by engaging in multidisciplinary fields. Outside of iGEM, she is involved in Stanford’s Vietnamese Student Association as a PR chair and Storyboarding Club as an artist. Occasionally, you can find her working on independent projects such as her indie video game or art portfolio projects.",
  },
  {
    id: 2,
    name: "Katie Han",
    year: "Bioengineering '24",
    img: {
      src: "https://static.igem.wiki/teams/4951/wiki/team-photos/katie-c.jpg",
      alt: "Picture of katie Han",
    },
    imgFun: {
      src: "https://static.igem.wiki/teams/4951/wiki/team-photos/katie2.jpg",
      alt: "Fun Picture of Katie Han",
    },
    email: "hankatie@stanford.edu",
    linkedin: "https://www.linkedin.com/in/katiehan0/",
    bio: "From Benicia, California, Katie is a senior majoring and coterming in Bioengineering. Her interests in neurodegenerative diseases and genomic engineering have led her to the Wernig lab, where she is currently exploring the genetic basis of how hematopoietic stem cells transdifferentiate into microglia-like cells. In previous summers, she participated in the Bio-X and NeURO fellowship programs, where she was able to conduct research. On campus, she is the financial officer for Side by Side, an a cappella group that sings music from the 1930s–70s at nursing homes, hospitals, and retirement centers. Outside of school and lab, Katie loves trying new boba shops with friends, singing, and spending time outdoors.",
  },
  {
    id: 3,
    name: "Nick Murphy",
    year: "Chemical Engineering '25",
    img: {
      src: "https://static.igem.wiki/teams/4951/wiki/team-photos/nick-c.jpg",
      alt: "Picture of Nick Murphy",
    },
    imgFun: {
      src: "https://static.igem.wiki/teams/4951/wiki/team-photos/nick2.jpg",
      alt: "Fun Picture of Nick Murphy",
    },
    email: "ngmurphy@stanford.edu",
    linkedin: "https://www.linkedin.com/in/nicholasgmurphy/",
    bio: "Nick is a driven junior majoring in Chemical Engineering. He thrives on applying scientific principles to real-world challenges, making a tangible difference. Previously, Nick interned at Lennham Pharmaceuticals and Tremeau Pharmaceuticals, where he investigated deuterated pharmaceuticals and non-steroidal anti-inflammatory drugs. Beyond the science realm, he's a surfer who catches waves in Half Moon Bay, finding solace and inspiration in the beauty of the ocean. Nick also expresses his creativity through playing the piano, using music as an outlet for self-expression. Nick is poised to leave a lasting impact in the world of science and beyond.",
  },
  {
    id: 4,
    name: "Zane Chan",
    year: "Bioengineering '25",
    img: {
      src: "https://static.igem.wiki/teams/4951/wiki/team-photos/zane-c.jpg",
      alt: "Picture of Zane Chan",
    },
    imgFun: {
      src: "https://static.igem.wiki/teams/4951/wiki/team-photos/zane2.jpg",
      alt: "Fun Picture of Zane Chan",
    },
    email: "zanechan@stanford.edu",
    linkedin: "https://www.linkedin.com/in/zane-chan-b5aa0122b/",
    bio: "Zane is a rising junior majoring in Bioengineering and minoring in Computer Science. He loves synthetic biology, dogs, and adventures (terrifyingly broadly defined). Zane would like to make gene therapies for dogs someday. Zane joined iGEM to build a stronger foundation in bioengineering. It takes a lot of practice! Some things he loves to do outside of school are backpacking, working on BioE projects (@stanford.biome), spikeball, reading, traveling, skiing, watching movies, triathlon training, and cooking", 
  },
  {
    id: 5,
    name: "Melissa Nguyen",
    year: "Electrical Engineering '26",
    img: {
      src: "https://static.igem.wiki/teams/4951/wiki/team-photos/melissa-c.jpg",
      alt: "Picture of Melissa Nguyen",
    },
    imgFun: {
      src: "https://static.igem.wiki/teams/4951/wiki/team-photos/mel2.jpg",
      alt: "Fun Picture of Melissa Nguyen",
    },
    email: "ngumel12@stanford.edu",
    linkedin: "",
    bio: "Melissa is a sophomore majoring in Electrical Engineering. With a passion for merging biology and computation, she aims to develop cutting-edge technology for biomedical purposes. Melissa's insatiable curiosity and dedication to scientific exploration drive her pursuit of knowledge in medical device development. In iGEM, she collaborates with like-minded peers to engineer innovative solutions using synthetic biology. Beyond the lab, Melissa finds joy in music and embraces her playful side with adorable pillow pets.",
  },
  {
    id: 6,
    name: "Akio Shirali",
    year: "Biocomputation '26",
    img: {
      src: "https://static.igem.wiki/teams/4951/wiki/team-photos/akio-c.jpg",
      alt: "Picture of Akio Shirali",
    },
    imgFun: {
      src: "https://static.igem.wiki/teams/4951/wiki/team-photos/akio2.jpg",
      alt: "Fun Picture of Akio Shirali",
    },
    email: "akios@stanford.edu",
    linkedin: "https://www.linkedin.com/in/akio-shirali/",
    bio: "Akio is a sophomore majoring in Biomedical Computation and Data Science. With interests in astrobiology, immunology, and synthetic biology, Akio’s curiosity knows no bounds. Currently, he does research at the Possu Huang Lab, where he studies protein design for immunotherapy. He hopes to learn more about the intersection of genetics and data analysis in order to improve human health. When he’s not in the lab, he enjoys the thrill of long-distance biking!",
  },
  {
    id: 7,
    name: "Iyshwary Warren",
    year: "Bioengineering '24",
    img: {
      src: "https://static.igem.wiki/teams/4951/wiki/team-photos/ivy.jpg",
      alt: "Picture of Iyshwary Warren",
    },
    imgFun: {
      src: "https://static.igem.wiki/teams/4951/wiki/team-photos/ivy2.jpg",
      alt: "Fun Picture of Iyshwary Warren",
    },
    email: "iwarren@stanford.edu",
    linkedin: "https://www.linkedin.com/in/ivwarren/",
    bio: "Iyshwary, nicknamed “Ivy,” is a rising senior majoring in Bioengineering. Coming from Tallahassee, Florida, she is interested in all things biology, but proteins especially. In past research experiences, she has worked on the development of protein inhibitors for SARS-CoV-2 to stop the spread of COVID-19, used MRI to track the progression of multiple sclerosis in mouse models, and created new technology to measure dissolved oxygen content from chlorella vulagaris in microgravity and on earth simultaneously. Currently, she works at the Wakatsuki Lab. In her free time, she loves to read, cook/bake, and play sports such as tennis or soccer.",
  },
];
